// extracted by mini-css-extract-plugin
export var discard = "_38-3";
export var muiTooltipTooltip = "_38-5";
export var notificationBar = "_38-2";
export var saveButtonHoverSlotWrapper = "_38-4";
export var show = "_38-1";
export var spacer = "_38-0";